import React, { useEffect } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Content } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { EditThemeContent } from './components/EditThemeContent';

export default function Home() {
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  const { id } = useParams();

  useEffect(() => {
    document.title = `Add Theme - Ubaform Admin`;
  }, []);

  let contentUi = <div className='loader-block' />;
  // if (!state.isLoading) {
  contentUi = (
    <React.Fragment>
      <EditThemeContent />
    </React.Fragment>
  );
  // }

  return (
    <div className='App'>
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      <main className='workspace'>
        <section className='breadcrumb lg:flex items-start'>
          <div>
            <h1>Edit Customer</h1>
            <ul>
              <li>
                <Link to='/customer-management'>Theme</Link>
              </li>

              <li className='divider la la-arrow-right'></li>
              <li>Edit Customer</li>
            </ul>
          </div>
          <div className='lg:flex items-center ml-auto mt-5 lg:mt-0'>
            <div className='flex mt-5 lg:mt-0'>
              <Link
                to={`/customer-management/add/${id}`}
                className='mr-3 bg-primary text-white font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Save Changes
              </Link>
              <Link
                to='/customer-management'
                className='bg-transparent text-primary font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Back to list
              </Link>
            </div>
          </div>
        </section>

        {contentUi}

        <Footer />
      </main>
    </div>
  );
}
